import { RuleTypeEnum } from "../../../domain/RuleType";
import { EnrichedYoutubeVideoRuleValue, YoutubeVideoRuleValue } from "../../../domain/ruleValue/YoutubeVideoRuleValue";
import { RuleValueStore, SerializedRuleValueStore } from "../RuleValueStore";

export class YoutubeVideoRuleValueStore implements RuleValueStore<RuleTypeEnum.YOUTUBE_VIDEO> {
    allowedIds: Set<string>;
    deniedIds: Set<string>;

    constructor() {
        this.allowedIds = new Set();
        this.deniedIds = new Set();
    }

    add(enrichedRuleValue: EnrichedYoutubeVideoRuleValue): void {
        if (enrichedRuleValue.action.isAllow()) {
            this.allowedIds.add(enrichedRuleValue.getValue().youtubeVideoId);
        } else {
            this.deniedIds.add(enrichedRuleValue.getValue().youtubeVideoId);
        }
    }

    serialize(): SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_VIDEO> {
        const data: SerializedYoutubeVideoRuleValueStoreData = {
            allowedIds: Array.from(this.allowedIds),
            deniedIds: Array.from(this.deniedIds),
        };
        return {
            type: RuleTypeEnum.YOUTUBE_VIDEO,
            data: data,
        };
    }

    fromSerialized(serialized: SerializedRuleValueStore<RuleTypeEnum.YOUTUBE_VIDEO>): void {
        this.allowedIds = new Set(serialized.data.allowedIds);
        this.deniedIds = new Set(serialized.data.deniedIds);
    }

    evaluateYoutubeVideoId(videoId: string): YoutubeVideoRuleValueStoreEvaluationResult {
        // Check whitelist
        if (this.allowedIds.has(videoId)) return "ALLOWED";

        // Check blacklist
        if (this.deniedIds.has(videoId)) return "DENIED";

        return "NO_MATCH";
    }
}

export interface SerializedYoutubeVideoRuleValueStoreData {
    allowedIds: string[];
    deniedIds: string[];
};

export type YoutubeVideoRuleValueStoreEvaluationResult = "ALLOWED" | "DENIED" | "NO_MATCH"